import * as yup from "yup";

export const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email('Please enter a valid email address').required("Required")
})


export const forgotPasswordInitialValues = {
  email: ''
}